<template>
         <div id="assets_content">
              <div class="fluid-container demo agenda_content">
                  <div class="row no_lm">
                      <div class="col-lg-12">
                          <div class="kt-portlet">
                                  <div class="kt-portlet__body">
                                      <input
                                        type="hidden"
                                        class="form-control"
                                        name="event_id"
                                        placeholder="Event Id"
                                        :value="item.event_id"
                                      />
                                      <tabs :options="{ useUrlFragment: false, defaultTabHash: 'theme-contents' }">
                                          <tab name="Theme Contents" :selected="true">
                                              <ThemeContentsTab />
                                          </tab>
                                          <tab name="Flags" >
                                            <FlagsTab/>
                                          </tab>
                                          <tab name="Banners">
                                            <BannersTab/>
                                          </tab>
                                          <tab name="Video Screens" >
                                            <VideoScreensTab/>
                                          </tab>
                                           <tab name="3D Models" >
                                              <ModelTab/>
                                            </tab>

                                          
                                        </tabs>
                                        <div class="container-fluid">
                                                    <div class="row">
                                                    <div class="offset-md-10 col-md-2">
                                                        <div class="setting_wrapper mt-2">
                                                        <button type="button" class="mb-1 mt-1 me-1  btn btn-primary" @click="submitForm">Update</button>
                                                        <button type="button" class="mb-1 mt-1 me-1 btn btn-secondary" @click="cancelClick">Cancel</button>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                    </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <FlashMessage group="exhibition_area_edit" />
</template>


<script>
import GeneralDashboardLayout from "@/components/layouts/GeneralDashboardLayout";
import {mapActions, mapGetters} from "vuex";
import BannersTab       from "@/components/cruds/ExhibitionHall/Tabs/BannersTab";
import FlagsTab         from "@/components/cruds/ExhibitionHall/Tabs/FlagsTab";
import ThemeContentsTab from "@/components/cruds/ExhibitionHall/Tabs/ThemeContentsTab";
import VideoScreensTab  from "@/components/cruds/ExhibitionHall/Tabs/VideoScreensTab";
import ModelTab         from  "@/components/cruds/ExhibitionHall/Tabs/3DModelTab";
import { gettingErrorMessage } from "@/services/GetValidationMessage";
  

export default {
  name: 'ExhibitionHallEdit',
  components: {
      BannersTab,
      VideoScreensTab,
      ThemeContentsTab,
      FlagsTab,
      ModelTab
  },
  data() {
      return {
          event_theme: null,
      };
  },
  computed: {
      ...mapGetters("ExhibitionAreasSingle", [
          "item",
          "loading"
         
      ])
  },
  async created() {
    this.setEvent(this.$route.params.event_id);
  },
  beforeUnmount() {
    this.resetState();
    delete this.$flashMessage.groups.exhibition_area_edit;
  },
 
  watch: {
      
  },
  methods: {
      ...mapActions("ExhibitionAreasSingle", [
          "fetchData",
          "updateData",
          "resetState",
          "setEvent",
          "setIsNew"
      ]),
      ...mapActions('ExhibitionAreasIndex', {fetchAllData:'fetchData'}),
      
      cancelEdit() {
        this.$router.back()
      },
      cancelClick() {
        this.resetState()
      },
      submitForm() {
        this.updateData()
        .then(() => {
          
           this.$flashMessage.show({
               group  : 'event_exhibition_area_index',
               type   : 'success',
               title  : 'Success',
               time   : 1200,
               html   : '<ul><li>Exhibition Area has been updated successfully.</li></ul>'
             });
             this.fetchAllData(this.$route.params.event_id);
                  
             this.resetState();
             //setTimeout(() =>  this.$router.push({ name: "event_dashboard.index"}), 2000);
        })
        .catch(error => {
          let html =  gettingErrorMessage(error);
            console.log("Error Event Exhibition Area",html)
            if (error.response.data.data.error) {
                this.$flashMessage.show({
                    group: 'exhibition_area_edit',
                    type: 'error',
                    title: 'Failed',
                    text: html || 'Something went wrong',
                    html: html
                });
            }
        });
         
      }
  }
};
</script>


<style>
.eventhall_flags .col-lg-4 {
  display: inline-block !important;
  margin-bottom: 50px;
  float: left;
  height: 100px;
}

label {
  display: inline;
}
.image-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.image-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.image-item img {
  width: 100px;
  height: 60px;
  object-fit: cover;
  border-radius: 5px;
}

.image-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.image-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.remove-btn {
  padding: 5px 10px;
  font-size: 14px;
  color: #fff;
  background-color: #e74c3c;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.remove-btn:hover {
  background-color: #c0392b;
}

    .event_detail_wrapper {
        border-bottom: 0px solid #ccc;
        padding: 10px 0px;
    
        .event_ls_label {
            font-weight: bold;
        }
    }
    
    .setting_wrapper {
        float: right;
    
        a {
            color: #201e1eba;
            padding: 9px;
            margin-left: 5px;
            background: #c0cdd345;
            border-radius: 4px;
            border: 1px solid #80808054;
        }
    }
    
    .toggle label {
        color: #000 !important;
    }
    
    .drop-files {
        margin-top: 10px;
    }
    
    .newspeaker {
        margin-top: 20px;
    }
    
    .newspeaker button {
        width: 100%;
    }
    
    .add_spk_btn {
        background-color: #0088CC;
        color: #fff;
    }
    
    .mini_txt {
        font-size: 0.8em;
        color: #585252;
        font-style: italic;
        margin-bottom: 10px;
    }
    
    .v-dialog>.v-overlay__content>.v-card {
        border-radius: 15px;
        padding-top: 20px;
    }
    
    .tabs-left .nav-tabs>li .active {
        border-left-color: #0088CC;
    }
    
    .orangebtn {
        background-color: orange;
    }
    
    .wrapp {
        display: block;
        text-align: center;
        margin-bottom: 10px;
    }
    .flash-content {
        z-index: 10;
    }
    
    .dark{
      --popper-theme-text-color: #ffffff;
      --popper-theme-padding: 15px;
      --popper-theme-background-color: #333333;
      --popper-theme-border-radius: 6px;
      --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
    }
    
    .tooltip_img img{    
        position: absolute;
        top: -53px;
        left: 50px;
        width: 300px;
        height: auto;
    }
</style>